import { TextInput } from "flowbite-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FaRegTimesCircle, FaTimes } from "react-icons/fa";
import { HiOutlineSearch } from "react-icons/hi";
import { useDispatch } from 'react-redux';
import { openSnackBar } from '../../../redux/snackBarReducer';
import NewMenu from "../NewMenu";

import './menutabletoolbar.scss';

function MenuTableToolbar(props) {
    const { t } = useTranslation();

    const dispatch = useDispatch();

    useEffect(() => {
    }, [])

    const [search, setSearch] = useState("");   //search bar text 
    const [filterArray, setFilterArray] = useState([]);

    const changeSearch = (e) => {
        setSearch(e.target.value);
    }

    const keyDownSearch = (e) => {
        var flag = false;
        if (e.keyCode === 13) {
            if (search.trim()) {
                if (filterArray.length > 0) {
                    filterArray.map(data => {
                        if (data.type === "text" && data.value === search.trim()) {
                            flag = true;
                        } else {
                            flag = false;
                        }
                    })
                }
                if (!flag) {
                    setFilterArray([...filterArray, { type: "text", value: search.trim() }]);
                    setSearch("");

                    const { setCondition, getData } = props;
                    setCondition("filterArray", [...filterArray, { type: "text", value: search.trim() }]);
                    setCondition("currentPage", 0);
                    getData();
                } else {
                    dispatch(openSnackBar({ status: "error", message: t("msg_filter_name_exist") }));
                }
            }
        }
    }

    const removeSelectedFilter = (index) => {
        filterArray.splice(index, 1);
        setFilterArray([...filterArray]);

        const { setCondition, getData } = props;
        setCondition("filterArray", [...filterArray]);
        setCondition("currentPage", 0);
        getData();
    }

    const removeAllFilter = () => {
        setFilterArray([]);

        const { setCondition, getData } = props;
        setCondition("filterArray", []);
        setCondition("currentPage", 0);
        getData();
    }

    return (
        <div>
            {/* <div className="flex pt-6 pb-2.5 px-4">
                <div className="px-2 flex-system-flex-end flex-wrap">
                    <TextInput
                        style={{width:'150px'}}
                        id="searchMenu"
                        type="search"
                        sizing="md"
                        placeholder={t("what_are_looking")}
                        required={true}
                        icon={HiOutlineSearch}
                        value={search}
                        onChange={(e) => changeSearch(e)}
                        onKeyDown={(e) => keyDownSearch(e)}
                    />
                </div>
                <div className="px-2">
                    <NewMenu />
                </div>
            </div> */}
            <div className="producttabletoolbar-layout">
                <div className="header">{t("wine_menus")}</div>
                <div className="actions">
                    <TextInput className="item tool-search"
                        id="searchProduct"
                        type="search"
                        sizing="md"
                        placeholder={t("what_are_looking")}
                        required={true}
                        icon={HiOutlineSearch}
                        value={search}
                        onChange={(e) => changeSearch(e)}
                        onKeyDown={(e) => keyDownSearch(e)}
                    />
                 
                    <div className="px-2 item">
                        <NewMenu />
                    </div>
                </div>
            </div>
            <div className="filter">
                {
                    filterArray?.length > 0 &&
                    <div className="flex pl-4 cursor-pointer" onClick={() => removeAllFilter()}>
                        <div className="inline-flex items-center text-sm font-medium text-slate-100 bg-red-100 rounded-full text-center px-4 py-2">
                            <span className="text-xs text-sitebg-50">{t("remove_all_tag")}</span>
                            <FaRegTimesCircle onClick={() => removeAllFilter()} className="ml-2 h-4 w-4 text-sitebg-50 " />
                        </div>
                    </div>
                }
                {
                    filterArray.map((data, i) =>
                        <div key={i} className="tag item">
                            <p className="tag-text mr-2" >{data.type !== "text" && `${data.type}:`}
                                <b className="text-xs"> "{data.value}"</b>
                            </p>
                            <FaTimes onClick={() => removeSelectedFilter(i)} className="cursor-pointer" />
                        </div>
                    )
                }
            </div>
        </div>
    );
}

export default MenuTableToolbar;
